export default "__VITE_ASSET__B0Dt$Ovw__"